/**
 * a Tooltip that shows website data
 */

import type { FunctionComponent, ReactNode } from "react";

import classNames from "classnames";

import { PopupHoverContainer } from "@similarweb/ui-components";

import { LOBTooltipContent } from "./LOBTooltipContent";

export interface ILOBTooltipProps {
  domain: string;
  mainDomainOnly?: boolean;
  placement?: string;
  debounce?: number;
  appendTo?: string;
  handleOpenQualificationSideBar?: (e: FixmeType) => void;
  children: ReactNode;
  className?: string;
}

export const LOBTooltip: FunctionComponent<ILOBTooltipProps> = ({
  placement = "top-left",
  ...props
}) => {
  return (
    <PopupHoverContainer
      content={() => (
        <LOBTooltipContent
          domain={props.domain}
          mainDomainOnly={props.mainDomainOnly}
          handleOpenQualificationSideBar={props.handleOpenQualificationSideBar}
        />
      )}
      config={{
        placement,
        cssClassContent: "Popup-content-infoCard",
        cssClassContainer: classNames("Popup-Container-infoCard", props.className),
        width: props.handleOpenQualificationSideBar ? 460 : 394,
        height: 204,
        allowHover: true,
        closeDelay: 50,
      }}
      debounce={props.debounce}
      appendTo={props.appendTo}
    >
      {props.children}
    </PopupHoverContainer>
  );
};

LOBTooltip.displayName = "LOBTooltip";
